export default "__VITE_ASSET__D5SswRj0__"